import React, { useEffect, useState } from "react";
import {
  Pagination,
} from "react-bootstrap";
import { API_URL } from "../../../services/apiConfig";
import axiosInstance from "../../../services/axios.instance";
import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../../types";


const MerchantPaymentDetails = () => {
  const accessToken = localStorage.getItem("access_token");

  const decodeToken = (token: any) => {
    if (token) {
      return JSON.parse(atob(token.split(".")[1]));
    } else {
      return null;
    }
  };

  const decodedToken = decodeToken(accessToken);
  const merchantId =
    decodedToken && decodedToken["merchant-id"]
      ? decodedToken["merchant-id"]
      : null;

  const [currentPage, setCurrentPage] = useState(0);
  const generatePageNumbers = (currentPage: number, totalPages: number) => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i);
    }
  
    if (currentPage <= 3) {
      return [0, 1, 2, 3, -1, totalPages - 2, totalPages - 1];
    }
  
    if (currentPage >= totalPages - 4) {
      return [0, 1, -1, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1];
    }
  
    return [0, 1, -1, currentPage - 1, currentPage, currentPage + 1, -1, totalPages - 1];
  };

  const fetchCustomerOrders = async (page: number) => {
    const response = await axiosInstance.get(
      `${API_URL.PURCHASE_ORDER}/${merchantId}?status=ALL&page=${page}`
    );
    return response?.data;
  };

  const { data: approvedOrders } = useQuery<ApiResponse>({
    queryKey: ["approvedOrders", currentPage],
    queryFn: () => fetchCustomerOrders(currentPage),
    
  });

  const [visiblePages, setVisiblePages] = useState<number[]>(() => {
    const totalPages = approvedOrders?.totalPages || 0;

    return totalPages >= 3
      ? [0, 1, 2]
      : Array.from({ length: totalPages }, (_, i) => i);
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    const totalPages = approvedOrders?.totalPages || 0;
    setVisiblePages(generatePageNumbers(page, totalPages));
  };

  useEffect(() => {
    if (approvedOrders?.totalPages) {
      setVisiblePages(generatePageNumbers(currentPage, approvedOrders.totalPages));
    }
  }, [approvedOrders, currentPage]);


  // const formatDate = (dateString: string) => {
  //   return new Date(dateString).toLocaleDateString();
  // };
  
  return (
    <div className="row">

      <div className="col-md-12 dashboard-table-div">
        <table className="table table-hover dashboard-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Order Number</th>
           
              <th>Status</th>
              <th>Product Name</th>
              <th>Payment Method</th>
              <th>Payment Status</th>
              <th>Total Amount</th>
           
            </tr>
          </thead>
          <tbody>
            {approvedOrders?.content?.map((order: any, index: number) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{order?.orderId}</td>
                <td>
                  {order.orderStatus === "MERCHANT_ORDER_ACCEPT" 
                    ? "ORDER ACCEPTED"
                    : order.orderStatus}
                </td>
                <td>{order?.products?.[0]?.productName}</td>
                <td>{order?.payment_method}</td>
                {/* <td>{order?.payment_status}</td> */}
                <td>
                  {order.payment_status === "PAYMENT_REFUNDED" 
                    ? "REFUNDED"
                    : order.payment_status}
                </td>
                 <td>{((order?.order_total_amount - order?.platform_charge - order?.delivery_boy_charge - order?.tax)).toFixed(2)}</td>
             
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        <div className="col-12 text-end">
        <Pagination className="pagination-align">
      <Pagination.Prev
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 0}
      />
      {visiblePages.map((pageNum, index) => (
        pageNum === -1 ? (
          <Pagination.Ellipsis key={`ellipsis_${index}`} />
        ) : (
          <Pagination.Item
            key={pageNum}
            active={pageNum === currentPage}
            onClick={() => handlePageChange(pageNum)}
          >
            {pageNum + 1}
          </Pagination.Item>
        )
      ))}
      <Pagination.Next
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === (approvedOrders?.totalPages ?? 0) - 1}
      />
    </Pagination>
</div>
     
    
    </div>
  );
};

export default MerchantPaymentDetails;



